import { render, staticRenderFns } from "./LinkedIn.vue?vue&type=template&id=ec934d24&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec934d24",
  null
  
)

export default component.exports